import "./nopage.scss"

const NoPage = ()=> {
  return (
    <div className="nopage">
        <h3 className="title">The page you are requesting cannot be found.</h3>
    </div>
  )
}

export default NoPage